import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AppHeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResizeService } from '../../dashboard/pages/dashboard/resize.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
// @ts-ignore
const packageJson = require('../../../../../package.json');

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [
    NzLayoutModule,
    RouterModule,
    AppHeaderComponent,
    SidenavComponent,
    AsyncPipe,
    NgIf,
  ],
})
export class LayoutComponent implements OnInit, OnDestroy {
  isMobile;
  version: string = packageJson?.version;
  private destroy$ = new Subject<void>();

  constructor(
    private deviceService: DeviceDetectorService,
    private router: Router,
    private resizeService: ResizeService,
  ) {
    this.isMobile = this.deviceService.isMobile();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.resizeService.triggerResize();
      });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadAnimation(outlet: any) {
    return 'FadeIn';
  }
}
